import React from "react";

export const PageHeader = ({ heading, subHeading, marginLeft }) => {
  return (
    <div
      className={`mt-6 pb-5 space-y-3 border-b border-gray-200 ${marginLeft}`}
    >
      <h1 className="font-semibold">{heading}</h1>
      <p className="text-sm text-gray-600">{subHeading}</p>
    </div>
  );
};
